import { useSelector } from "react-redux";
import WidgetCards from "./WidgetCards";
import { TicketWidgetRefreshTime } from "../../../../Constants";
import { useEffect, useState } from "react";
import { GetLastRefreshDateTime, GetWidgetData, GetWidgetSettings, GridMetaData_Format } from "../../../../Helper/Services";
import { GetFormattedGridData, IsSharedFilterAlert } from "../../../../Helper/WidgetDataCommon";
import { UpdatedWidgetData } from "../TableWidget/TableWidgetService";

const TicketWidget = (props) => {
    const sessionId = useSelector((state) => state.login.sessionId);
    const isOtherUserPage = useSelector((state) => state.layout.IsOtherUserPage);
    const sharedUserEmail = useSelector((state) => state.layout.SharedUserEmail);
    const [widgetDt, setWidgetDt] = useState([]);
    const [screenMsg, setScreenMsg] = useState("No Data");
    const [showNoData, setShowNoData] = useState(false);

    useEffect(() => {
        const getWidgetSetting = () => {
            let isSharedFilter = false;
            let sharedFilterUserId = "";
            let filterId = "";

            GetWidgetSettings(props.widgetId, sessionId)
                .then((widgetSettings) => {
                    if (
                        widgetSettings["IsSharedFilter"] !== undefined &&
                        widgetSettings["IsSharedFilter"] === "true"
                    ) {
                        isSharedFilter = true;
                        sharedFilterUserId = widgetSettings["OriginalUserId"];
                        filterId = widgetSettings["FilterId"];
                    }


                    GetWidgetData(
                        widgetSettings["Filter"],
                        widgetSettings["reports"],
                        widgetSettings["connection"],
                        sessionId,
                        isOtherUserPage,
                        sharedUserEmail,
                        isSharedFilter,
                        sharedFilterUserId,
                        filterId
                    )
                        .then((widgetDataResponse) => {
                            GetLastRefreshDateTime(widgetSettings["reports"], widgetSettings["connection"], sessionId)
                                .then((lstReponseDt) => {
                                    props.onGetNotification(lstReponseDt);
                                    const metaData = GridMetaData_Format(widgetDataResponse);
                                    console.log("metaData", metaData);
                                    if (IsSharedFilterAlert(widgetDataResponse)) {
                                        setScreenMsg(widgetDataResponse);
                                        setShowNoData(true);
                                        return false;
                                    }

                                    const getFormattedDt =
                                        GetFormattedGridData(widgetDataResponse).splice(0, parseInt(widgetSettings["numberOfTickets"]));
                                    console.log("getFormattedDt", getFormattedDt);
                                    const getDateTimeConvertedDt = UpdatedWidgetData(
                                        metaData,
                                        getFormattedDt
                                    ).map((item, index) => {
                                        return {
                                            id: index,
                                            title: item[widgetSettings["titleText"]],
                                            description: item[widgetSettings["subTitleText"]],
                                            owner: item[widgetSettings["username"]],
                                            percent: item["percentageOfTarget"] ? `${Math.round(item["percentageOfTarget"] * 100)}%` : "0%",
                                            topLeftText: item[widgetSettings["topLeftLabel"]],
                                            imageUrl: item[widgetSettings["imagePath"]],
                                            openDate: item["Opened"] ? new Date(item["Opened"]).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' }) : "N/A",
                                            promiseDate: item["PromiseDate"] ? new Date(item["PromiseDate"]).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' }) : "N/A",
                                            status: item['Status'] ? item['Status'] : "N/A",
                                        };
                                    });
                                    setWidgetDt(getDateTimeConvertedDt);
                                    if (getDateTimeConvertedDt.length === 0) {
                                        setShowNoData(true);
                                    }
                                })
                                .catch((err) => {
                                    console.error("GetLastRefreshDateTime:-", err);
                                });
                        })
                        .catch((err) => {
                            console.error("GetWidgetData:-", err);
                        });
                })
                .catch((err) => { });
        };

        if (sessionId !== "" && sessionId != null) {
            getWidgetSetting();

        }

        window.addEventListener("resize", () => {
            console.log("resize event");
        });

        const refreshWidget = setInterval(() => {
            getWidgetSetting();
        }, TicketWidgetRefreshTime);

        return () => {
            //clear setinterval on unmount component
            clearInterval(refreshWidget);
        };
    }, [sessionId, props.RefreshVersion]);

    return <>
        <WidgetCards cardsData={widgetDt} />
        {widgetDt.length === 0 && showNoData === true && (
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "rgb(153, 153, 153)",
                    fontSize: "17px",
                }}
            >
                {screenMsg}
            </div>
        )}
    </>;
}

export default TicketWidget;